import { PlaygroundSessionStore } from '../PlaygroundSessionStore.js';

const cvStore = new PlaygroundSessionStore('pg_client_versions', 5);
const featStore = new PlaygroundSessionStore('pg_game_features', 5);
const attrStore = new PlaygroundSessionStore('pg_player_attributes', 5);
const catStore = new PlaygroundSessionStore('pg_attribute_categories', 5);
const tmplStore = new PlaygroundSessionStore('pg_content_templates', 5);

const parseData = (config) => typeof config.data === 'string' ? JSON.parse(config.data) : (config.data || {});
const now = () => new Date().toISOString();
const gameId = (config) => config.headers?.['X-Web-Game-Id'];

// ── Client Versions ──────────────────────────────────────────────────
export function handleGetClientVersions(config) {
    const gid = gameId(config);
    const all = cvStore.getAll();
    const filtered = gid ? all.filter(v => v.gameId === gid) : all;
    return { versions: filtered };
}

export function handleCreateClientVersion(config) {
    const data = parseData(config);
    return cvStore.create({ ...data, gameId: gameId(config) });
}

export function handleUpdateClientVersion(config, match) {
    return cvStore.update(match[1], parseData(config));
}

// ── Game Features ────────────────────────────────────────────────────
export function handleGetGameFeatures(config) {
    const gid = gameId(config);
    const all = featStore.getAll();
    return gid ? all.filter(f => f.gameId === gid) : all;
}

export function handleCreateGameFeature(config) {
    const data = parseData(config);
    return featStore.create({
        ...data,
        gameId: gameId(config),
        versionInfo: {
            version: 1,
            parentEntityId: PlaygroundSessionStore.getNextId(),
            auditInfo: { lastModifiedBy: 'Playground Explorer', lastModifiedDate: now() },
            versionDescription: 'Created in playground', latest: true,
        },
    });
}

export function handleUpdateGameFeature(config, match) {
    return featStore.update(match[1], parseData(config));
}

// ── Player Attributes ────────────────────────────────────────────────
export function handleGetPlayerAttributes(config) {
    const gid = gameId(config);
    const all = attrStore.getAll();
    const filtered = gid ? all.filter(a => a.gameId === gid) : all;
    return { playerAttributes: filtered };
}

export function handleCreatePlayerAttribute(config) {
    const data = parseData(config);
    return attrStore.create({ ...data, gameId: gameId(config) });
}

export function handleUpdatePlayerAttribute(config, match) {
    return attrStore.update(match[1], parseData(config));
}

export function handleDeletePlayerAttribute(config, match) {
    attrStore.delete(match[1]);
    return { success: true };
}

export function handleRenamePlayerAttribute(config, match) {
    const data = parseData(config);
    return attrStore.update(match[1], { name: data.name || data.newName });
}

export function handleMovePlayerAttribute(config, match) {
    const data = parseData(config);
    return attrStore.update(match[1], { categoryId: data.categoryId || data.targetCategoryId });
}

// ── Attribute Categories ─────────────────────────────────────────────
export function handleGetAttributeCategories(config) {
    const gid = gameId(config);
    const all = catStore.getAll();
    const filtered = gid ? all.filter(c => c.gameId === gid) : all;
    return { attributeCategories: filtered };
}

export function handleCreateAttributeCategory(config) {
    const data = parseData(config);
    return catStore.create({ ...data, gameId: gameId(config) });
}

export function handleUpdateAttributeCategory(config, match) {
    return catStore.update(match[1], parseData(config));
}

export function handleDeleteAttributeCategory(config, match) {
    catStore.delete(match[1]);
    return { success: true };
}

// ── Player Attribute Management (combined view) ──────────────────────
export function handleGetAllAttributeData(config) {
    return {
        attributes: attrStore.getAll(),
        categories: catStore.getAll(),
    };
}

// ── Content Templates ────────────────────────────────────────────────
export function handleGetContentTemplates(config) {
    const gid = gameId(config);
    const all = tmplStore.getAll();
    return gid ? all.filter(t => t.gameId === gid) : all;
}

export function handleGetContentTemplate(config, match) {
    return tmplStore.getById(match[1]) || {};
}

export function handleCreateContentTemplate(config) {
    const data = parseData(config);
    return tmplStore.create({
        ...data,
        gameId: gameId(config),
        versionInfo: {
            version: 1,
            parentEntityId: PlaygroundSessionStore.getNextId(),
            auditInfo: { lastModifiedBy: 'Playground Explorer', lastModifiedDate: now() },
            versionDescription: 'Created in playground', latest: true,
        },
    });
}

export function handleUpdateContentTemplate(config, match) {
    return tmplStore.update(match[1], parseData(config));
}

export function handleDeleteContentTemplate(config, match) {
    tmplStore.delete(match[1]);
    return { success: true };
}
